import React from 'react';
import { Link } from "react-router-dom";
import logo from './logo.svg';
import loadSvg from './load.svg';
const Menu = ({history, path}) => {
	const [ load, setLoad ] = React.useState(false);
	let items = null, lastLi = 7; 
	let sesion = JSON.parse(localStorage.getItem("sesion"));

	const logout = () =>{
		setLoad(!load)
		fetch(
			window.$api+'/logout',
			{
				method : 'POST',
				headers : {	'Content-Type': 'application/json' },
				body : JSON.stringify({ 
					email : sesion.email,
					token : sesion.token
				})
			}
		).then(res=>res.json())
		.then(res=>{
			if( res.token === false ){
				setLoad(!load);
				localStorage.removeItem('sesion');
				history.push('/');
			}
		});
	}
	const actived = (modulo) =>{
		return path === modulo ? 'actived' : '';
	}

		if( sesion.rol === 1 ){
			lastLi = 7;
			items = (
					<>
						<li key={0}><Link to="/dashboard" className={actived('dashboard')}><i className="icon-dashboard"></i><span>Dashboard</span></Link></li>
						<li key={1}><Link to="/inventario" className={actived('inventario')}><i className="icon-dashboard"></i><span>Inventario</span></Link></li>
						<li key={2}><Link to="/usuarios" className={actived('usuarios')}><i className="icon-user-menu"></i><span>Usuarios</span></Link></li>
						<li key={3}><Link to="/sucursales" className={actived('sucursales')}><i className="icon-sucursales"></i><span>Sucursales</span></Link></li>
						<li key={4}><Link to="/reportegeneral" className={actived('reportegeneral')}><i className="icon-reportes"></i><span>Reportes</span></Link></li>
						<li key={5}><Link to="/descuentos" className={actived('descuentos')}><i className="icon-reportes"></i><span>Descuentos</span></Link></li>
						<li key={6}><Link to="/productos" className={actived('productos')}><i className="icon-productos"></i><span>Productos</span></Link></li>
						
					</>
				);
		}else if( sesion.rol === 3 ){
			lastLi = 5;
			items = (
				<>
					
					<li key={1}><Link to="/inventario" className={actived('inventario')}><i className="icon-dashboard"></i><span>Inventario</span></Link></li>
					<li key={2}><Link to="/sucursales" className={actived('sucursales')}><i className="icon-sucursales"></i><span>Sucursales</span></Link></li>
					<li key={3}><Link to="/productos" className={actived('productos')}><i className="icon-productos"></i><span>Productos</span></Link></li>
					{/* <li key={4}><Link to="/egresos" className={actived('egresos')}><i className="icon-dashboard"></i><span>Egresos</span></Link></li> */}
					
				</>);
		}else{
			lastLi = 4;
			items = (
				<>
					<li key={0}><Link to="/caja" className={actived('dashboard')}><i className="icon-sucursales"></i><span>Caja</span></Link></li>
					<li key={1}><Link to="/reportedecajas" className={actived('reportedecajas')}><i className="icon-dashboard"></i><span>Reportes</span></Link></li>
					<li key={2}><Link to="/inventario" className={actived('inventario')}><i className="icon-dashboard"></i><span>Inventario</span></Link></li>
					
				</>);			
		}
		return(
			<>
				<img src={logo} className="shantal-logo" alt="logo" />
				<hr className="lineMenu"/>
				<ul className="menu">
					{ items }
					<li key={lastLi} onClick={logout}><i className="icon-salir"></i><span>Salir</span></li>
				</ul>
				<div className={load ? 'load show' : 'load' }>
					<img src={loadSvg} alt='load'/>
				</div>
			</>
		)
}
export default Menu;